module.exports = __webpack_public_path__ + "media/images/ico-pencil-2534ed0b.svg";